import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout.js';
import { AssetDetailPage, AssetsPage } from './pages/AssetsPage.js';
import { AuditPage } from './pages/AuditPage.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { IngestedImageDetailPage } from './pages/ingestedImages/IngestedImageDetailPage.js';
import { IngestedImagesPage } from './pages/ingestedImages/IngestedImagesPage.js';
import { ArtworkPage } from './pages/artwork/ArtworkPage.js';
import { ArtworkDetailPage } from './pages/artwork/ArtworkDetailPage.js';
import { PersonalizationPage } from './pages/personalization/PersonalizationPage.js';
import { TextLayoutsPage } from './pages/textLayouts/TextLayoutsPage.js';
import { ProductTemplatesPage } from './pages/productTemplates/ProductTemplatesPage.js';
import { PromptReviewPage } from './pages/PromptReviewPage.js';
import { SettingsPage } from './pages/SettingsPage.js';
import { ConceptCreatePage } from './pages/concepts/ConceptCreatePage.js';
import { ConceptDetailPage } from './pages/concepts/ConceptDetailPage.js';
import { ConceptsListPage } from './pages/concepts/ConceptsListPage.js';
import { ImageRequestDetailPage } from './pages/imageRequests/ImageRequestDetailPage.js';
import { ImageRequestsListPage } from './pages/imageRequests/ImageRequestsListPage.js';
import { ResearchCreatePage } from './pages/research/ResearchCreatePage.js';
import { ResearchDetailPage } from './pages/research/ResearchDetailPage.js';
import { ResearchListPage } from './pages/research/ResearchListPage.js';

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'research', element: <ResearchListPage /> },
      { path: 'research/new', element: <ResearchCreatePage /> },
      { path: 'research/:id', element: <ResearchDetailPage /> },
      { path: 'concepts', element: <ConceptsListPage /> },
      { path: 'concepts/new', element: <ConceptCreatePage /> },
      { path: 'concepts/:id', element: <ConceptDetailPage /> },
      { path: 'prompt-review', element: <PromptReviewPage /> },
      { path: 'image-requests', element: <ImageRequestsListPage /> },
      { path: 'image-requests/:id', element: <ImageRequestDetailPage /> },
      { path: 'assets', element: <AssetsPage /> },
      { path: 'assets/:id', element: <AssetDetailPage /> },
      { path: 'ingested-images', element: <IngestedImagesPage /> },
      { path: 'ingested-images/:id', element: <IngestedImageDetailPage /> },
      { path: 'artwork', element: <ArtworkPage /> },
      { path: 'artwork/:id', element: <ArtworkDetailPage /> },
      { path: 'personalization', element: <PersonalizationPage /> },
      { path: 'text-layouts', element: <TextLayoutsPage /> },
      { path: 'product-templates', element: <ProductTemplatesPage /> },
      { path: 'audit', element: <AuditPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
